module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Light-Alphabetic.1e73ffbf.woff";